import { useEffect, useState, useCallback } from 'react';

import { type ThemeConfig } from 'antd';

import { createResource, useThemeRefreshInterval } from '@eduzz/shared';

import createTheme from '../createTheme';

const handleThemeCreation = async (mode: 'light' | 'dark', enableAnimation?: boolean) => {
  const createdTheme = await createTheme(mode, enableAnimation ?? false);
  return createdTheme;
};

const themeResource = createResource('antd-remote-theme', () => handleThemeCreation('light', true).then(res => res));

export const useRemoteTheme = (mode: 'light' | 'dark', enableAnimation?: boolean) => {
  const remoteThemeVars = themeResource.read();
  const [theme, setTheme] = useState<ThemeConfig>(remoteThemeVars);

  const requestTheme = useCallback(async () => {
    const fetchedTheme = await createTheme(mode, enableAnimation ?? false);
    setTheme(fetchedTheme);
  }, [enableAnimation, mode]);

  useEffect(() => {
    document.body.classList.remove('eduzz-ui-disable-animation', 'eduzz-ui-light-theme', 'eduzz-ui-dark-theme');
    document.body.classList.add(`eduzz-ui-${mode}-theme`);

    if (!enableAnimation) {
      document.body.classList.add('eduzz-ui-disable-animation');
    }

    requestTheme();
  }, [mode, enableAnimation, requestTheme]);

  useThemeRefreshInterval(requestTheme);

  return theme;
};
